module.exports = __webpack_public_path__ + "img/58.6ac91a84.png";